import React from "react";
import Button from "../../Button";
import Overlay from "../../Overlay";
import excalamation from "../../../assets/img/icons/table/excalamation.svg";

function ResultatUnlockConfirm({ onConfirm, onCancel, open = true }) {
  const handleCloseDialog = () => {
    onCancel();
  };

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <Overlay show={open} closable={true} onClick={handleCloseDialog}>
      <div className="delete-confirm-wrapper">
        <div className="delete-confirm-container">
          <div className="are-you-sure">
            <img src={excalamation} alt={"excalamation"} />
            <p>Déverrouillage du mode résultat</p>
          </div>

          <h1 className="popup-desc-content">
            Vous allez déverrouiller le mode résultat à partir du mois
            sélectionné. Si des mois suivants sont aussi verrouillés, alors ils
            seront automatiquement déverrouillés également.
          </h1>

          <div className="delete-button-containers">
            <Button
              text={"Annuler"}
              onClick={handleCloseDialog}
              className={"action-button action-button-cancel"}
            />
            <Button
              text={"Oui je confirme et je déverrouille"}
              onClick={handleConfirm}
              className={"action-button agree-action-button"}
            />
          </div>
        </div>
      </div>
    </Overlay>
  );
}

export default ResultatUnlockConfirm;
